/**
 * Whether a consent prompt actually ADDS scopes to prior consent. False for
 * a first consent (nothing prior) and for a re-confirmation — a native
 * client or a `prompt=consent` request whose grant already covers everything
 * asked. Native clients see a consent card on EVERY login (oidc-provider's
 * native_client_prompt), so keying the "New —" wording off the mere
 * existence of a grant would stamp "New" on scopes approved long ago, every
 * single sign-in.
 */
export function consentIsIncremental(
  scopes: string[],
  grantedScopes: string[],
): boolean {
  const granted = new Set(grantedScopes);
  return grantedScopes.length > 0 && scopes.some((s) => !granted.has(s));
}
